module.exports = __webpack_public_path__ + "img/icon_guoqi.6408ad64.png";